module.exports = __webpack_public_path__ + "img/logo.74cf2fe9.svg";